export const getInputColors = props => `
  color: ${props.theme.colors.textSecondary};
  ${
    props.showUnderline
      ? `;
  border-color: ${props.theme.commons.input.focusColor};
  color: ${props.theme.commons.input.focusColor};`
      : ''
  }
  ${
    props.showErrorMessage
      ? `border-color: ${props.theme.commons.input.errorColor};
    color: ${props.theme.commons.input.errorColor};`
      : ''
  }
  ${
    props.showSuccessMessage
      ? `border-color: ${props.theme.commons.input.successColor};
        color: ${props.theme.commons.input.successColor};
      `
      : ''
  }
`;

export const getUnderLineBgColor = props => `
  ${
    props.showUnderline
      ? `background-color: ${props.theme.commons.input.focusColor};`
      : ''
  }
  ${
    props.showErrorMessage
      ? `background-color: ${props.theme.commons.input.errorColor};`
      : ''
  }
  ${
    props.showSuccessMessage
      ? `background-color: ${props.theme.commons.input.successColor};`
      : ''
  }
`;
